var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBackGuaranteeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 65,
    viewBox: "0 0 84 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.37637 48.283C0.832481 48.6785 0.728326 49.4189 1.14373 49.9368L12.8549 64.5365C13.2703 65.0544 14.0479 65.1536 14.5918 64.758L26.7792 55.8951C27.3231 55.4996 27.4272 54.7591 27.0118 54.2412L15.3007 39.6415C14.8853 39.1237 14.1076 39.0245 13.5637 39.42L1.37637 48.283ZM19.9086 57.0292C21.1062 57.0292 22.0771 56.1047 22.0771 54.9644C22.0771 53.824 21.1062 52.8996 19.9086 52.8996C18.7109 52.8996 17.74 53.824 17.74 54.9644C17.74 56.1047 18.7109 57.0292 19.9086 57.0292Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0561 1.27917C48.4092 3.34396 45.6211 1.57414 45.6211 1.57414L48.6456 8.48558C48.8597 8.40359 49.0936 8.35847 49.3386 8.35847H55.5344C55.6786 8.35847 55.8189 8.37409 55.9536 8.40365L58.9422 1.57414C58.9422 1.57414 56.1948 -0.115458 53.0561 1.27917Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1527 23.1915C50.8417 22.9068 50.6862 22.5107 50.6862 22.0032C50.6862 21.4585 50.8482 21.0253 51.1721 20.7034C51.509 20.3816 51.9559 20.1897 52.5131 20.1278V23.8785C51.93 23.7052 51.4766 23.4762 51.1527 23.1915Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1173 29.1517C54.7933 29.4983 54.3464 29.7149 53.7763 29.8016V26.0324C54.3593 26.2057 54.8063 26.4347 55.1173 26.7194C55.4412 26.9917 55.6031 27.3754 55.6031 27.8705C55.6031 28.3657 55.4412 28.7927 55.1173 29.1517Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.9653 31.5299C37.6222 22.5818 45.9964 13.7079 48.1939 11.5228C48.5094 11.7579 48.9068 11.8981 49.3386 11.8981H55.5344C55.8857 11.8981 56.2141 11.8054 56.4943 11.6442C58.769 13.9149 66.3044 21.9865 67.6164 30.4813C68.1398 33.87 67.7424 36.5403 66.7006 38.5902C66.0478 38.8353 65.4382 39.0724 64.8643 39.3008C64.9526 39.1857 65.0347 39.069 65.1106 38.951C65.8754 37.7617 66.0741 36.2326 64.9569 35.018C63.951 33.9244 62.1569 33.431 59.8716 33.431C58.9957 33.431 57.9661 33.5545 56.9036 33.7069C56.4388 33.7736 55.9776 33.8442 55.5084 33.9161C54.852 34.0166 54.1802 34.1194 53.4618 34.2172C51.0387 34.5468 48.5855 34.7391 46.4837 34.3388C45.4115 34.1347 44.2225 33.7714 42.8877 33.3339C42.5907 33.2366 42.2862 33.1355 41.9755 33.0323C40.9157 32.6804 39.7833 32.3044 38.6224 31.9699C38.0823 31.8142 37.5294 31.6655 36.9653 31.5299ZM57.3522 29.5045C57.6761 28.9599 57.8381 28.3781 57.8381 27.7591C57.8381 26.9422 57.6502 26.3047 57.2745 25.8467C56.8987 25.3763 56.4388 25.0359 55.8946 24.8255C55.3505 24.6026 54.6444 24.3922 53.7763 24.1942V20.1836C54.2298 20.295 54.5925 20.5054 54.8646 20.8149C55.1367 21.1119 55.2922 21.4523 55.331 21.8361H57.702C57.6113 20.8087 57.2162 20.0041 56.5165 19.4223C55.8298 18.8281 54.9164 18.4815 53.7763 18.3825V16.8785H52.5131V18.3825C51.2952 18.4939 50.3105 18.89 49.559 19.5708C48.8076 20.2393 48.4319 21.0872 48.4319 22.1146C48.4319 22.9316 48.6197 23.5752 48.9955 24.0456C49.3841 24.516 49.8506 24.8626 50.3947 25.0854C50.9389 25.2958 51.645 25.5063 52.5131 25.7167V29.8016C51.9819 29.7149 51.5737 29.5169 51.2887 29.2074C51.0037 28.8856 50.8417 28.4833 50.8028 28.0005H48.4319C48.4319 29.0156 48.8076 29.8325 49.559 30.4515C50.3105 31.0704 51.2952 31.4355 52.5131 31.5469V33.0509H53.7763V31.5469C54.6184 31.4727 55.344 31.2499 55.9529 30.8785C56.5748 30.5072 57.0413 30.0492 57.3522 29.5045Z",
    fill: "url(#paint4_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7236 52.604L16.8102 40.2152C19.9081 36.9705 22.3865 33.4309 28.8921 32.251C35.3978 31.0711 41.5937 34.6107 46.2406 35.4957C50.8875 36.3806 56.7735 34.6107 59.8715 34.6107C68.5457 34.6107 63.8988 42.28 55.2246 41.3951C46.5504 40.5102 43.1426 42.28 46.8601 42.8699C50.5777 43.4599 54.605 44.3448 58.3225 43.1649C62.04 41.985 65.4478 39.9202 74.4318 37.2655C81.619 35.1417 83.2092 37.1672 83.106 38.4454C76.9101 41.985 63.1553 49.7723 57.7029 52.604C50.8875 56.1436 52.1266 56.7336 43.1426 54.0788C35.9554 51.955 29.2019 52.2107 26.7236 52.604Z",
    fill: "url(#paint5_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0992 10.1286C48.0992 9.63984 48.5153 9.24365 49.0286 9.24365H55.8441C56.3574 9.24365 56.7735 9.63984 56.7735 10.1286C56.7735 10.6173 56.3574 11.0135 55.8441 11.0135H49.0286C48.5153 11.0135 48.0992 10.6173 48.0992 10.1286Z",
    fill: "#F54748"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 14.0778,
    y1: 39.1777,
    x2: 14.0778,
    y2: 65.0003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E32223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD6C6D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 52.4058,
    y1: 0.727539,
    x2: 52.4058,
    y2: 39.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 52.4058,
    y1: 0.727539,
    x2: 52.4058,
    y2: 39.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 52.4058,
    y1: 0.727539,
    x2: 52.4058,
    y2: 39.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 52.4058,
    y1: 0.727539,
    x2: 52.4058,
    y2: 39.3008,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7374"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22123"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 55.0809,
    y1: 33.9348,
    x2: 57.8161,
    y2: 51.8273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22123"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7374"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBackGuaranteeIcon);
export default __webpack_public_path__ + "static/media/money_back_guarantee_icon.86c4f0890be8a650bb5daa071462c0a8.svg";
export { ForwardRef as ReactComponent };